import React, { useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { AnimatePresence, motion } from "framer-motion";
import { AiOutlineLogout } from "react-icons/ai";
import { HiUserGroup, HiOutlineDocumentReport } from "react-icons/hi";
import { MdAccountTree, MdWaterDrop } from "react-icons/md";
import HomeContainer from "./Admin/HomeContainer";
import ApplicationsContainer from "./Admin/ApplicationsContainer";
import ProfileContainer from "./Admin/ProfileContainer";
import AdminContainer from "./Admin/AdminContainer";
import PropertiesContainer from "./Admin/PropertiesContainer";
import CustomersContainer from "./Admin/CustomersContainer";
import ProgramsContainer from "./Admin/ProgramsContainer";
import { getUsersStatus } from "../../features/user";
import { HiOutlineBars3 } from "react-icons/hi2";

import {
  selectAllPrograms,
  getProgramStatus,
  fetchPrograms,
} from "../../features/program";
import { getUploadStatus, fetchUploads } from "../../features/programUpload";
import { getFieldStatus, fetchFields } from "../../features/programField";
import {
  fetchProperties,
  getPropertyStatus,
  propertyCount,
  propertyCountStatus,
} from "../../features/properties";
import {
  fetchApplicationStatus,
  getStatus,
} from "../../features/applicationStatus";

import {
  getApplicationStatus,
  getApplicationCountStatus,
  fetchApplicationCount,
  getInitialApplicationsStatus,
  fetchInitialApplications,
} from "../../features/application";
import {
  fetchStatusList,
  getStatusListStatus,
  fetchStatusLogs,
  getStatusLogStatus,
} from "../../features/status";
import acwdLogo from "../../assets/Acwdlogo-Hi-Res_png.png";
import FieldAssignmentsContainer from "./Admin/FieldAssignmentsContainer";

const AdminView = ({ props }) => {
  const dispatch = useDispatch();
  const usersStatus = useSelector(getUsersStatus);

  const programs = useSelector(selectAllPrograms);
  const programStatus = useSelector(getProgramStatus);
  const uploadStatus = useSelector(getUploadStatus);
  const propertyStatus = useSelector(getPropertyStatus);
  const fieldStatus = useSelector(getFieldStatus);
  const appStatus = useSelector(getStatus);
  const statusListStatus = useSelector(getStatusListStatus);
  const applicationStatus = useSelector(getApplicationStatus);
  const statusLogStatus = useSelector(getStatusLogStatus);
  const applicationCountStatus = useSelector(getApplicationCountStatus);
  const initialApplicationsStatus = useSelector(getInitialApplicationsStatus);
  const countStatus = useSelector(propertyCountStatus);

  useEffect(() => {
    programStatus === "idle" && dispatch(fetchPrograms());
    countStatus === "idle" && dispatch(propertyCount());

    // applicationStatus === "idle" && dispatch(fetchApplications());
    uploadStatus === "idle" && dispatch(fetchUploads());
    propertyStatus === "idle" && dispatch(fetchProperties());
    fieldStatus === "idle" && dispatch(fetchFields());
    appStatus === "idle" && dispatch(fetchApplicationStatus());
    statusListStatus === "idle" && dispatch(fetchStatusList());
    statusLogStatus === "idle" && dispatch(fetchStatusLogs());
    applicationCountStatus === "idle" && dispatch(fetchApplicationCount());
    initialApplicationsStatus === "idle" &&
      dispatch(fetchInitialApplications());
  }, [
    programStatus,
    applicationStatus,
    uploadStatus,
    propertyStatus,
    fieldStatus,
    appStatus,
    statusListStatus,
    statusLogStatus,
    applicationCountStatus,
    dispatch,
  ]);

  return (
    <div className="main-content transistion flex min-h-screen duration-200 dark:bg-gray-900">
      <div className="w-full">
        <Sidebar
          showSidebar={props.sidebarOpen}
          toggleSidebar={props.toggleSidebar}
          selectMenu={props.selectMenu}
          menuOptions={props.menuOptions}
          type={props.role}
          logoutUser={props.logoutUser}
        />

        <div className="flex w-full flex-col">
          <div className="sticky top-0 z-50 flex h-[5rem] w-full items-center justify-end gap-1 md:gap-12 border-b-2 border-gray-200 bg-[#7d7d7d] pr-3 pl-3 md:pr-8 font-semibold tracking-wide text-white shadow-xl dark:bg-gray-800">
            <div className="mr-auto flex gap-2 md:gap-4 md:p-8 text-lg font-medium text-white">
              <img
                src={acwdLogo}
                alt="ACWD Logo"
                className="h-8 align-middle self-center"
              />
              {/* <img
                src={hubLogo}
                alt="Water Savings Center"
                className="h-8 align-middle"
              /> */}
              <span className="font-montserrat text-[12px] leading-[15px] md:text-lg md:leading-normal self-center">
                ACWD WATER SAVINGS CENTER
              </span>
            </div>
            <ul className="flex items-center text-white">
              {/* <li
                className="hover:text-gray-200  cursor-pointer rounded-lg"
                onClick={() => {
                  props.logoutUser();
                }}
              >
                <div className="flex gap-2">
                  <AiOutlineLogout size="24" />
                  <span className="">Logout</span>
                </div>
              </li> */}
              <li className="cursor-pointer rounded-lg hover:text-gray-200">
                {localStorage.getItem("user_id") != 123 && (
                  <>
                    <div 
                      className="flex gap-2 md:hidden"
                      onClick={() => {
                        props.toggleSidebar();
                      }}
                    >
                      <HiOutlineBars3 size="24" />
                    </div>
                    
                    <div 
                      className="hidden gap-2 md:flex"
                      onClick={() => {
                        props.logoutUser();
                      }}
                    >
                      <AiOutlineLogout size="24" />
                      <span className="">Logout</span>
                    </div>
                  </>
                )}
              </li>
            </ul>
          </div>
          <AnimatePresence exitBeforeEnter initial={false}>
            {/* {props.menuOptions[0] && usersStatus === "loading" && (
              <p>Loading ...</p>
            )} */}
            {props.menuOptions[0] && props.role === "ADMIN" && 
              window.innerWidth >= 768 && (
              <HomeContainer props={{ sidebarOpen: props.sidebarOpen }} />
            )}
            {props.menuOptions[0] &&
              props.role === "ADMIN" &&
              usersStatus === "succeeded" && 
              window.innerWidth < 768 && (
                <FieldAssignmentsContainer props={{ sidebarOpen: props.sidebarOpen, view: "fieldAssignments" }} />
              )}
            {/* {props.menuOptions[0] && usersStatus === "failed" && (
              <p>failed to load resources</p>
            )} */}
            {props.menuOptions[1] && props.role === "ADMIN" && (
              <ApplicationsContainer
                props={{ sidebarOpen: props.sidebarOpen }}
              />
            )}
            {props.menuOptions[0] && props.role === "CONTRACTOR" && (
              <ApplicationsContainer
                props={{ sidebarOpen: props.sidebarOpen }}
              />
            )}
            {props.menuOptions[2] && props.role === "ADMIN" && (
              <ProgramsContainer
                props={{
                  sidebarOpen: props.sidebarOpen,
                  title: "Programs",
                  icon: <MdWaterDrop size="32" />,
                  programs: programs,
                  data: [
                    [
                      "Toilet Rebate Program",
                      "Drought Resistant Landscaping Program",
                      "Program 3",
                    ],
                    [
                      {
                        step: 1,
                        status_name: "Customer Submit/Update",
                        days_pending: 7,
                      },
                      {
                        step: 2,
                        status_name: "Agency Review",
                        days_pending: 28,
                      },
                      {
                        step: 3,
                        status_name: "Pending Installation",
                        days_pending: 180,
                      },
                      {
                        step: 4,
                        status_name: "Complete",
                        days_pending: null,
                      },
                    ],
                    [
                      {
                        field_name: "# of Bathrooms in Building:",
                        field_type: "Numeric",
                      },
                      {
                        field_name: "# of Tank Toilets in Building:",
                        field_type: "Numeric",
                      },
                      {
                        field_name: "# of Flushometer Toilets in Building:",
                        field_type: "Numeric",
                      },
                      {
                        field_name: "# of Urinals in Building:",
                        field_type: "Numeric",
                      },
                    ],
                    [
                      { description: "# of Bathrooms in Building:" },
                      { description: "# of Tank Toilets in Building:" },
                      {
                        description: "# of Flushometer Toilets in Building:",
                      },
                      {
                        description: "# of Urinals in Building:",
                      },
                    ],
                  ],
                }}
              />
            )}
            {props.menuOptions[3] && props.role === "ADMIN" && (
              <CustomersContainer
                props={{
                  sidebarOpen: props.sidebarOpen,
                  title: "Customers",
                  icon: <HiUserGroup size="32" />,
                  data: [
                    {
                      id: 1,
                      name: "John Doe",
                      property: "Residential",
                      address: "17 Main St",
                      associatedApplications: 180,
                      cumulativeSavings: "n/a",
                      cumulativeCosts: "n/a",
                    },
                    {
                      id: 1,
                      name: "John Doe 2",
                      address: "17 Main St",
                      property: "Residential",
                      associatedApplications: 180,
                      cumulativeSavings: "n/a",
                      cumulativeCosts: "n/a",
                    },
                  ],
                }}
              />
            )}
            {props.menuOptions[4] && props.role === "ADMIN" && (
              <PropertiesContainer props={{ sidebarOpen: props.sidebarOpen }} />
            )}

            {props.menuOptions[6] && props.role === "ADMIN" && (
              <AdminContainer props={{ sidebarOpen: props.sidebarOpen }} />
            )}
            {props.menuOptions[7] && props.role === "ADMIN" && (
              <ProfileContainer props={{ sidebarOpen: props.sidebarOpen }} />
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default AdminView;
